import A1 from './aplCatlPolicy/A1Data.vue';
import A2 from './aplCatlPolicy/A2Data.vue';
import A4 from './aplCatlPolicy/A4Data.vue';
import A5 from './aplCatlPolicy/A5Data.vue';
import A6 from './aplCatlPolicy/A6Data.vue';
import A7 from './aplCatlPolicy/A7Data.vue';
import A9 from './aplCatlPolicy/A9Data.vue';
import AB from './aplCatlPolicy/ABData.vue';
import AC from './aplCatlPolicy/ACData.vue';
import AD from './aplCatlPolicy/ADData.vue';
import AE from './aplCatlPolicy/AEData.vue';
import AF from './aplCatlPolicy/AFData.vue';
import AG from './aplCatlPolicy/AGData.vue';
import B1 from './aplCatlPolicy/B1Data.vue';
import B2 from './aplCatlPolicy/B2Data.vue';
import B3 from './aplCatlPolicy/B3Data.vue';
import B4 from './aplCatlPolicy/B4Data.vue';
import B5 from './aplCatlPolicy/B5Data.vue';
import B6 from './aplCatlPolicy/B6Data.vue';
import B7 from './aplCatlPolicy/B7Data.vue';
import BA from './aplCatlPolicy/BAData.vue';
import BC from './aplCatlPolicy/BCData.vue';
import BD from './aplCatlPolicy/BDData.vue';
import C1 from './aplCatlPolicy/C1Data.vue';
import C2 from './aplCatlPolicy/C2Data.vue';
import C4 from './aplCatlPolicy/C4Data.vue';
import D1 from './aplCatlPolicy/D1Data.vue';
import IQ from './aplCatlPolicy/IQData.vue';
import MULTIPAYCHANGE from './AplCatlMultiPayChangeData.vue';
import MULTIENOTIFY from './AplCatlMultiENotifyData.vue';
import PON4300 from './AplCatlPon4300Data.vue';
import ACH from './AplCatlACHData.vue';
import CREDITCARDEXP from './AplCatlCreditCardExpData.vue';
import CREDITCARDAUTH from './AplCatlCreditCardAuthData.vue';

export default {
    ACH,
    A1,
    A2,
    A4,
    A5,
    A6,
    A7,
    A9,
    AB,
    AC,
    AD,
    AE,
    AF,
    AG,
    B1,
    B2,
    B3,
    B4,
    B5,
    B6,
    B7,
    BA,
    BC,
    BD,
    C1,
    C2,
    C4,
    CREDITCARDEXP,
    D1,
    IQ,
    MULTIPAYCHANGE,
    MULTIENOTIFY,
    PON4300,
    CREDITCARDAUTH,
};
